<template>
  <div id="pifu">
      <div class="title">
          <h2>姑苏区财政局关于批复{{data.divname}}{{openYear}}年度<br/>部门{{openType}}的通知</h2>
      </div>
      <div class="name">
          {{data.divname}}：
      </div>
      <div class="text">
          区二届人大常委会第39次会议已经批准{{openYear}}年度区级部门{{openType}}。根据《中华人民共和国预算法》及其实施条例、财政财务管理有关规定，经审核，现批复你部门{{openYear}}年度{{openType}}。
      </div>
      <div class="text">
         <span class="bold"> 一、基本收支情况</span>
      </div>
      <div class="text">
          <span class="bold">（一）总收支。</span>{{openYear}}年度年初结转和结余{{tableData.a}}万元，本年收入{{tableData.b}}万元，本年支出{{tableData.c}}万元，使用非财政拨款结余{{tableData.d}}万元，结余分配{{tableData.e}}万元，年末结转和结余{{tableData.f}}万元。
      </div>
      <div class="text">
          <span class="bold">（二）一般公共预算财政拨款收支。</span>{{openYear}}年度一般公共预算财政拨款年初结转和结余{{tableData.g}}万元，本年收入{{tableData.h}}万元，本年支出{{tableData.i}}万元，年末结转和结余{{tableData.j}}万元。
      </div>
      <div class="text">
          <span class="bold">（三）政府性基金预算财政拨款收支。</span>{{openYear}}年度政府性基金预算财政拨款年初结转和结余{{tableData.k}}万元，本年收入{{tableData.l}}万元，本年支出{{tableData.m}}万元，年末结转和结余{{tableData.n}}万元。
      </div>
      <div class="text">
          <span class="bold">（四）国有资本经营预算财政拨款收支。</span>{{openYear}}年度国有资本经营预算财政拨款年初结转和结余0万元，本年收入0万元，本年支出0万元，年末结转和结余0万元。
      </div>
      <div class="text">
         <span class="bold">二、有关工作要求</span> 
      </div>
      <div class="text">
          （一）本批复文件作为你部门对预算执行有关事项进行调整的依据，调整事项涉及会计处理的应当遵循政府会计准则制度的规定。
      </div>
      <div class="text">
          （二）基本建设项目竣工{{openType}}审批按现行制度管理，以竣工{{openType}}批复数据为准；年度基本建设资金收入支出及结转结余资金不作为基本建设项目竣工{{openType}}审批的依据。
      </div>
      <div class="text">
          （三）你部门应当自财政部批复{{openType}}之日起15日内，依据本批复文件向所属单位批复{{openType}}。
      </div>
      <div class="text">
          （四）请你部门依法依规履行公开主体责任和义务，做好本部门{{openType}}公开工作，及时将公开情况反馈我部。经部门批复的所属单位{{openType}}，应当在批复后20日内向社会公开，并对有关事项作出说明。
      </div>
      <div class="text">
          （五）请你部门按照{{openType}}审核审计意见，进一步加强财务管理，改进预算编制，规范预算执行和会计核算，提高预算绩效管理水平。
      </div>
      <div class="text">
          附件：{{openYear}}年度部门{{openType}}批复表
      </div>
          <div class="right">
          苏州市姑苏区财政局
      </div>
      <div class="right">
          {{openYear + 1}}年7月13日
      </div> 
  </div>
</template>

<script>
import $ from 'jquery'
import { getDivList } from '@/api/index.js'
import "@/api/jquery.wordexport"
export default {
    data(){
        return{
            data:{},
            divid:'',
            tableData:{},
            openType:this.$store.state.openType == 'js' ? '决算' : '预算',
            openYear:this.$store.state.openYear,
        }
    },
    created(){
        this.divid = this.$route.query.divid
        this.init()
    },
    methods:{
        async init(){
            let res = await getDivList({id:this.divid})
            if(res.status == 0){
                this.data = res
                this.tableData.a = res.tables.find(e=>e.name=='1').rows["28"].b ? this.isMoney(res.tables.find(e=>e.name=='1').rows["28"].b) : 0  //表1的34B
                this.tableData.b = res.tables.find(e=>e.name=='1').rows["26"].b ? this.isMoney(res.tables.find(e=>e.name=='1').rows["26"].b) : 0  //表1的32B
                this.tableData.c = res.tables.find(e=>e.name=='1').rows["26"].d ? this.isMoney(res.tables.find(e=>e.name=='1').rows["26"].d) : 0  //表1的32D
                this.tableData.d = res.tables.find(e=>e.name=='1').rows["27"].b ? this.isMoney(res.tables.find(e=>e.name=='1').rows["27"].b) : 0  //表1的33B
                this.tableData.e = res.tables.find(e=>e.name=='1').rows["27"].d ? this.isMoney(res.tables.find(e=>e.name=='1').rows["27"].d) : 0  //表1的33D
                this.tableData.f = res.tables.find(e=>e.name=='1').rows["28"].d ? this.isMoney(res.tables.find(e=>e.name=='1').rows["28"].d) : 0  //表1的34D
                this.tableData.g = res.tables.find(e=>e.name=='4').rows["28"].b ? this.isMoney(res.tables.find(e=>e.name=='4').rows["28"].b) : 0  //表4的35B
                this.tableData.h = res.tables.find(e=>e.name=='4').rows["0"].b ? this.isMoney(res.tables.find(e=>e.name=='4').rows["0"].b) : 0  //表4的7B
                this.tableData.i = res.tables.find(e=>e.name=='4').rows["26"].d ? this.isMoney(res.tables.find(e=>e.name=='4').rows["26"].e) : 0  //表4的33E
                this.tableData.j = res.tables.find(e=>e.name=='4').rows["27"].d ? this.isMoney(res.tables.find(e=>e.name=='4').rows["27"].d) : 0  //表4的34D
                this.tableData.k = res.tables.find(e=>e.name=='10').rows['0'].e ? this.isMoney(res.tables.find(e=>e.name=='10').rows['0'].e) : 0 //表10的9E
                this.tableData.l = res.tables.find(e=>e.name=='10').rows['0'].f ? this.isMoney(res.tables.find(e=>e.name=='10').rows['0'].f) : 0 //表10的9F
                this.tableData.m = res.tables.find(e=>e.name=='10').rows['0'].g ? this.isMoney(res.tables.find(e=>e.name=='10').rows['0'].g) : 0 //表10的9G
                this.tableData.n = res.tables.find(e=>e.name=='10').rows['0'].j ? this.isMoney(res.tables.find(e=>e.name=='10').rows['0'].j) : 0 //表10的9J

                this.word()
            }
        },
        word(){
            this.$nextTick(() => {
                $("#pifu").wordExport(this.data.divname);
            }, 1000);
        }
    }
}
</script>

<style scoped>
    #pifu{
        font-size: 21px !important;
        font-family: FangSong !important;
        line-height: 2em !important;
    }
    .title{
        text-align: center;
    }
    .text{
        text-indent:2em
    }
    .right{
        text-align: right;
    }
    .bold{
        font-weight: bold;
    }
</style>